import React from "react";
import Movie from "./movies/components/Movies/Movies.js";
import Search from "./movies/components/MovieSearch/MovieSearch.js";
import { MovieContextProvider } from "./movies/contexts/movieContext.js";
import MovieSlider from "./movies/components/Slider/MovieSlider.js";
import { motion } from "framer-motion";

function Movies(props) {
  const containerVariants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: { delay: 0.5, duration: 1.5 },
    },
  };
  return (
    <React.Fragment>
      <MovieContextProvider>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          style={{
            maxWidth: "1000px",
            minWidth: "50%",
            margin: "0 auto",
          }}
        >
          {" "}
          <br />
          <MovieSlider />
          <br />
          <Search />
          <br />
          <Movie />
        </motion.div>
      </MovieContextProvider>
    </React.Fragment>
  );
}
export default Movies;
